import { addAddressesWithNoDuplicates } from '../normalizers/uiNeeds';
import { commonTypes } from '../common';

export const types = {
};

export const initialState = {
  myProductsInfo: {},
};

const UINeedsMyProductsReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_MY_PRODUCTS_INFO: {
      const {
        addresses,
        mobileLinesOver6Months,
        linesMobile,
        clientCategory,
      } = action.payload;

      const newAddressesArray = addAddressesWithNoDuplicates(state.clientAddresses, addresses);

      const newState = {
        ...state,
        myProductsInfo: {
          ...state.myProductsInfo,
          addresses,
          mobileLinesOver6Months,
          linesMobile,
          loaded: true,
          clientCategory,
        },
        clientAddresses: newAddressesArray,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
};

export default UINeedsMyProductsReducer;
